import { useEphemeral } from '../state/ephemeral'

export function useIsOnline(userId: string | null | undefined): boolean {
  return useEphemeral((s) => (userId ? Boolean(s.online[userId]) : false))
}
